var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-container',[_c('h2',{staticClass:"text-2xl mb-4"},[_vm._v("That didn’t work... "),_c('router-link',{staticClass:"text-full-blue",attrs:{"to":"/account"}},[_vm._v("Try again")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }